/* -------------------------------------------------------------------------- */
/* NUMBER UTILS                                                               */
/* -------------------------------------------------------------------------- */

export const numbers = {
    fa: ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'],
    ar: ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
    en: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
};

/**
 * Validate digit
 *
 * @param {*} digit
 * @returns {boolean}
 */
export const NotValidDigit = (digit) => digit === null || digit === false || typeof digit === 'undefined';
